import { AgentService } from '../services/agent.service';
import { AgentRecruitmentStepFormHandlerComponent } from './agent-recruitment-step-form.handler';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { Location } from '@angular/common';

@Component({
  selector: 'sym-agent-recruitment-step-form',
  templateUrl: './agent-recruitment-step-form.component.html',
  styleUrls: ['./agent-recruitment-step-form.component.scss'],
})
export class AgentRecruitmentStepFormComponent extends AgentRecruitmentStepFormHandlerComponent {
  constructor(
    service: AgentService,
    route: ActivatedRoute,
    router: Router,
    location: Location,
    settingService: SettingService,
    headerService: HeaderService
  ) {
    super(service, route, router, location, settingService, headerService);
  }
}
